// extracted by mini-css-extract-plugin
export default {"heading":"Gv-z","corrected":"Hv-z","redirectVerbiageContainer":"Iv-z","redirectVerbiageText":"Jv-z"};